import { useEffect, useState } from "react";
import { MapPin, ChevronDown, ChevronUp } from "lucide-react";
import { api } from "@/lib/api";
import { siteGapsLines } from "@/lib/coverage";
import { ownLocations } from "@/lib/scope";

// Round K/L — a bedrijfsleider's OWN open site questions, one line part per location.
// Fail-soft: on any error, nothing shows.
export const SiteGapsLine = ({ user, questions, onPick, refreshKey }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const hasSite = ownLocations(user).length > 0;

  useEffect(() => {
    if (!hasSite) return undefined;
    let alive = true;
    api.get("/me/coverage").then(({ data: d }) => alive && setData(d)).catch(() => alive && setData(null));
    return () => { alive = false; };
  }, [hasSite, refreshKey]);

  const groups = (data?.per_location || []).filter((p) => p.open_count > 0);
  const line = siteGapsLines(groups);
  if (!hasSite || !line) return null;
  const byId = new Map((questions || []).map((q) => [q.id, q]));

  return (
    <div className="mb-6 border border-tw bg-tw-surface tw-fadeup" data-testid="site-gaps">
      <button type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open} data-testid="site-gaps-toggle"
        className="tw-press w-full flex items-center gap-2 px-4 py-3 text-left hover:bg-white/5 transition-colors duration-150">
        <MapPin size={14} strokeWidth={2.5} className="text-tw-yellow shrink-0" />
        <span className="flex-1 min-w-0 text-sm text-white font-medium break-words" data-testid="site-gaps-line">{line}</span>
        {open ? <ChevronUp size={14} className="text-tw-muted shrink-0" /> : <ChevronDown size={14} className="text-tw-muted shrink-0" />}
      </button>
      {open && (
        <div className="border-t border-tw" data-testid="site-gaps-list">
          {groups.map((g) => (
            <section key={g.name} data-testid={`site-gaps-group-${g.name}`}>
              <div className="px-4 pt-3 pb-1 font-mono text-[10px] uppercase tracking-[0.2em] text-tw-yellow">{g.name}</div>
              <ul className="divide-y divide-tw">
                {g.open.map((item) => <GapItem key={item.id} item={item} q={byId.get(item.id)} onPick={onPick} site={g.name} />)}
              </ul>
            </section>
          ))}
        </div>
      )}
    </div>
  );
};

const GapItem = ({ item, q, onPick, site }) => (
  <li>
    <button type="button" disabled={!q} onClick={() => q && onPick(q)} data-testid={`site-gaps-item-${site}-${item.id}`}
      className="tw-press w-full text-left px-4 py-3 text-sm text-white hover:text-tw-yellow disabled:text-tw-muted transition-colors duration-150 break-words">
      {item.text}
      {item.category && <span className="ml-2 font-mono text-[10px] uppercase tracking-[0.15em] text-tw-muted">{item.category}</span>}
    </button>
  </li>
);
